import React, { ReactNode } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useApi } from "../Api-provider/ApiContext";
import {
  BenchmarkQueriesContext,
  GeneralQueriesContext,
  PlaidQueriesContext,
  TaggerQueriesContext
} from "../../../queries/query-context";
import useGetQueries from "../../../queries/query-services";

interface IStoreProviderProps {
  children: ReactNode;
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});

export const QueryProvider = ({ children }: IStoreProviderProps): JSX.Element => {
  const apiContext = useApi();
  const queries = useGetQueries({ apiContext });

  return (
    <QueryClientProvider client={queryClient}>
      <TaggerQueriesContext.Provider value={queries.taggerQueries}>
        <BenchmarkQueriesContext.Provider value={queries.benchmarkQueries}>
          <GeneralQueriesContext.Provider value={queries.generalQueries}>
            <PlaidQueriesContext.Provider value={queries.plaidQueries}>{children}</PlaidQueriesContext.Provider>
          </GeneralQueriesContext.Provider>
        </BenchmarkQueriesContext.Provider>
      </TaggerQueriesContext.Provider>
    </QueryClientProvider>
  );
};

QueryProvider.displayName = "QueryProvider";
